import React from 'react';
import { AnimatedSection, AnimatedItem } from './AnimatedSection';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'María R.',
    quote: 'Este libro me dio las palabras que nunca supe cómo expresar. Por primera vez en mi vida, sentí que alguien realmente entendía mi dolor y me mostraba una salida llena de luz.',
    stars: 5
  }, {
    name: 'Carmen L.',
    quote: 'Una lectura transformadora. Las herramientas prácticas que Daniela comparte me han ayudado a establecer límites que antes creía imposibles. Es un abrazo al alma.',
    stars: 5
  }, {
    name: 'Ana P.',
    quote: 'Rompiendo el Silencio no es solo un libro, es un compañero de sanación. Me dio la valentía para comenzar mi propio proceso terapéutico sin sentir vergüenza.',
    stars: 4
  }];
  return <section className="bg-cream py-24 px-6" data-id="element-234">
      <div className="max-w-6xl mx-auto" data-id="element-235">
        <AnimatedSection className="text-center mb-16" data-id="element-236">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-237">
            Lo Que Dicen Nuestros Lectores
          </h2>
          <div className="w-24 h-1 bg-amber mx-auto rounded-full opacity-50" data-id="element-238"></div>
        </AnimatedSection>

        <AnimatedSection stagger className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-239">
          {testimonials.map((testimonial, index) => <AnimatedItem key={index} className="bg-white p-8 rounded-2xl shadow-warm flex flex-col h-full relative" data-id="element-240">
              <div className="absolute top-0 right-8 -mt-4 text-6xl text-amber/20 font-playfair" data-id="element-241">
                "
              </div>
              <div className="flex space-x-1 mb-6" data-id="element-242">
                {[...Array(5)].map((_, i) => <Star key={i} className={`w-5 h-5 ${i < testimonial.stars ? 'text-amber fill-amber' : 'text-gray-300'}`} data-id="element-243" />)}
              </div>
              <p className="text-medium-brown italic mb-8 flex-1 text-lg leading-relaxed" data-id="element-244">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center space-x-3" data-id="element-245">
                <div className="w-10 h-10 rounded-full bg-warm-beige flex items-center justify-center text-terracotta font-bold font-playfair" data-id="element-246">
                  {testimonial.name.charAt(0)}
                </div>
                <span className="font-semibold text-deep-brown" data-id="element-247">
                  {testimonial.name}
                </span>
              </div>
            </AnimatedItem>)}
        </AnimatedSection>
      </div>
    </section>;
}